import styles from './EmptyComponent.module.scss';
const EmptyComponent = ({ title = 'Tu', normalText = 'nič nie je', children}) => {
  return (
    <div className={styles.empty}>
      <div className="container">
        <h2>
          {title} {normalText ? <span className="block w-full">{normalText}</span> : ''}
        </h2>
        {children}
      </div>
    </div>
  );
};
export default EmptyComponent;
